import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../../core/has.js";
import { isNone as e, isSome as r } from "../../../../core/maybe.js";
import { c as s } from "../../../../chunks/mat3f32.js";
import { brushes as t } from "../brushes.js";
import { Container as i } from "../Container.js";
import n from "./ClippingInfo.js";
import { WGLDrawPhase as o } from "./enums.js";

var a = /*#__PURE__*/function (_i) {
  _inherits(a, _i);

  var _super = _createSuper(a);

  function a() {
    var _this;

    _classCallCheck(this, a);

    _this = _super.apply(this, arguments), _this.name = _this.constructor.name;
    return _this;
  }

  _createClass(a, [{
    key: "clips",
    set: function set(e) {
      this._clips = e, this.children.forEach(function (r) {
        return r.clips = e;
      }), this._updateClippingInfo();
    }
  }, {
    key: "_createTransforms",
    value: function _createTransforms() {
      return {
        dvs: s()
      };
    }
  }, {
    key: "doRender",
    value: function doRender(e) {
      var r = this.createRenderParams(e),
          s = r.painter,
          t = r.globalOpacity,
          i = r.profiler,
          n = r.drawPhase,
          _a = n === o.LABEL || n === o.HIGHLIGHT ? 1 : t * this.computedOpacity;

      i.recordContainerStart(this.name), s.beforeRenderLayer(r, this._clippingInfos ? 255 : 0, _a), this.updateTransforms(e.state), this.renderChildren(r), s.compositeLayer(r, _a), i.recordContainerEnd();
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(r) {
      e(this._renderPasses) && (this._renderPasses = this.prepareRenderPasses(r.painter));

      var _iterator = _createForOfIteratorHelper(this.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;

          _e.beforeRender(r);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this._renderPasses),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e2 = _step2.value;

          try {
            _e2.render(r);
          } catch (s) {}
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.children),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _e3 = _step3.value;

          _e3.afterRender(r);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "createRenderParams",
    value: function createRenderParams(e) {
      return e.requireFBO = this.requiresDedicatedFBO, e;
    }
  }, {
    key: "prepareRenderPasses",
    value: function prepareRenderPasses(e) {
      var _this2 = this;

      return [e.registerRenderPass({
        name: "clip",
        brushes: [t.clip],
        target: function target() {
          return _this2._clippingInfos;
        },
        drawPhase: o.MAP | o.LABEL | o.LABEL_ALPHA | o.DEBUG | o.HIGHLIGHT
      })];
    }
  }, {
    key: "updateTransforms",
    value: function updateTransforms(e) {
      var _iterator4 = _createForOfIteratorHelper(this.children),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r = _step4.value;

          _r.setTransform(e);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      _get(_getPrototypeOf(a.prototype), "onAttach", this).call(this), this._updateClippingInfo();
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      _get(_getPrototypeOf(a.prototype), "onDetach", this).call(this), this._updateClippingInfo();
    }
  }, {
    key: "_updateClippingInfo",
    value: function _updateClippingInfo() {
      var _this3 = this;

      if (r(this._clippingInfos) && (this._clippingInfos.forEach(function (e) {
        return e.destroy();
      }), this._clippingInfos = null), !this.stage) return;
      var e = this._clips;
      r(e) && e.length && (this._clippingInfos = e.items.map(function (e) {
        return n.fromClipArea(_this3.stage, e);
      })), this.requestRender();
    }
  }]);

  return a;
}(i);

export { a as default };